import { useLayoutEffect, useRef } from 'react';

const useEqualHeight = (boxClassName: string, dependency?: any) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (containerRef.current && boxClassName) {
      const boxes = containerRef.current.querySelectorAll(`.${boxClassName}`);
      const MIN_HEIGHT = 70; // Minimum height in pixels

      let maxHeight = 0;
      boxes.forEach((box) => {
        if (box instanceof HTMLElement) {
          const boxHeight = box.offsetHeight;
          if (boxHeight > maxHeight) {
            maxHeight = boxHeight;
          }
        }
      });

      const finalHeight = Math.max(maxHeight, MIN_HEIGHT);

      boxes.forEach((box) => {
        if (box instanceof HTMLElement) {
          box.style.height = `${finalHeight}px`;
        }
      });
    }
  }, [boxClassName, dependency]);

  return containerRef;
};

export default useEqualHeight;
